import { gql } from '@apollo/client'

export const GET_VOOH_CAMPAIGN_POTENTIAL = gql`
  query voohCampaignPotential($voohCampaignId: ID!) {
    voohCampaignPotential(voohCampaignId: $voohCampaignId) {
      brand
      network
      month
      totalMoveMinutes
      totalClubMinutes
      takenMoveMinutes
      takenClubMinutes
    }
  }
`
